import { render, staticRenderFns } from "./TruckingSchedule.vue?vue&type=template&id=2d18c0a7&scoped=true&"
import script from "./TruckingSchedule.vue?vue&type=script&lang=js&"
export * from "./TruckingSchedule.vue?vue&type=script&lang=js&"
import style0 from "./TruckingSchedule.vue?vue&type=style&index=0&id=2d18c0a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d18c0a7",
  null
  
)

export default component.exports